(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["atlp-label-checkout-confirmation"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var component = document.querySelector('[data-atlp-label-check]');
    if (!component || component.dataset.atlpInitialised === 'true') return;

    component.dataset.atlpInitialised = 'true';

    var overlay = component.querySelector('.atlp-label-check__overlay');
    var confirmButton = component.querySelector('[data-atlp-label-check-confirm]');
    var guideLink = component.querySelector('[data-atlp-label-check-guide]');
    var closeButton = component.querySelector('[data-atlp-label-check-close]');
    var checkoutSelector = '.btn-checkout, button[name="checkout"], input[name="checkout"]';
    var focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    var isCheckingCart = false;
    var isContinuing = false;
    var bypassControl = null;
    var pendingCheckout = null;
    var previousFocus = null;
    var previousBodyOverflow = '';
    var previousHtmlOverflow = '';
    var refreshTimer = null;

    function normalise(value) {
      return String(value || '').toLowerCase();
    }

    function atlpCartContainsLabels(cart) {
      var items = cart && Array.isArray(cart.items) ? cart.items : [];

      return items.some(function (item) {
        var searchableFields = [
          item && item.product_title,
          item && item.title,
          item && item.handle,
          item && item.product_type
        ];

        return searchableFields.some(function (field) {
          return normalise(field).indexOf('label') !== -1;
        });
      });
    }

    function getShopRoot() {
      var root = '/';

      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        root = String(window.Shopify.routes.root);
      }

      return root.slice(-1) === '/' ? root : root + '/';
    }

    function getCart() {
      return fetch(getShopRoot() + 'cart.js', {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: {
          Accept: 'application/json'
        }
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('Cart request failed with status ' + response.status);
        }

        return response.json();
      });
    }

    function setLabelCartState(hasLabels) {
      if (!document.body) return;
      document.body.classList.toggle('atlp-label-cart', Boolean(hasLabels));
    }

    function isFullCartPage() {
      var cartPath = getShopRoot() + 'cart';
      return window.location.pathname.replace(/\/$/, '') === cartPath.replace(/\/$/, '');
    }

    function refreshAcceleratedCheckoutState() {
      if (!isFullCartPage()) return Promise.resolve(false);

      return getCart()
        .then(function (cart) {
          var hasLabels = atlpCartContainsLabels(cart);
          setLabelCartState(hasLabels);
          return hasLabels;
        })
        .catch(function (error) {
          setLabelCartState(false);
          console.warn('[ATLP Label Check] Could not refresh accelerated checkout state.', error);
          return false;
        });
    }

    function scheduleAcceleratedCheckoutRefresh() {
      if (!isFullCartPage()) return;
      window.clearTimeout(refreshTimer);
      refreshTimer = window.setTimeout(refreshAcceleratedCheckoutState, 150);
    }

    function isCheckoutControl(control) {
      if (!control || control.closest('[data-atlp-label-check]')) return false;
      if (control.closest('[data-atlp-accelerated-checkout], .additional-checkout-buttons, .additional_checkout_buttons')) return false;

      var name = normalise(control.getAttribute('name'));
      var form = control.form || control.closest('form');
      var formAction = form ? normalise(form.getAttribute('action')) : '';

      if (control.matches('.btn-checkout')) {
        return Boolean(
          control.closest('#dropdown-cart') ||
          isFullCartPage() ||
          formAction.indexOf('/cart') !== -1
        );
      }

      return name === 'checkout' && formAction.indexOf('/cart') !== -1;
    }

    function isUnavailable(control) {
      return Boolean(
        control.disabled ||
        control.getAttribute('aria-disabled') === 'true' ||
        control.classList.contains('disabled')
      );
    }

    function getCheckoutDestination(control) {
      var destination = control.getAttribute('data-checkout-url') ||
        control.getAttribute('href') ||
        control.getAttribute('formaction');

      if (!destination) {
        var inlineHandler = control.getAttribute('onclick') || '';
        var match = inlineHandler.match(/(?:window\.)?location(?:\.href)?\s*=\s*['"]([^'"]+)['"]/i);
        if (match) destination = match[1];
      }

      return destination || getShopRoot() + 'checkout';
    }

    function setControlBusy(control, busy) {
      if (!control || !control.classList) return;

      control.classList.toggle('atlp-label-check__checkout-busy', busy);

      if (busy) {
        control.setAttribute('aria-busy', 'true');
      } else {
        control.removeAttribute('aria-busy');
      }
    }

    function getFocusableElements() {
      return Array.prototype.slice.call(component.querySelectorAll(focusableSelector)).filter(function (element) {
        return !element.hidden && element.getAttribute('aria-hidden') !== 'true';
      });
    }

    function openModal(opener) {
      previousFocus = opener || document.activeElement;
      previousBodyOverflow = document.body ? document.body.style.overflow : '';
      previousHtmlOverflow = document.documentElement.style.overflow;

      component.hidden = false;

      if (document.body) document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';

      window.requestAnimationFrame(function () {
        if (confirmButton) confirmButton.focus();
      });
    }

    function closeModal(options) {
      var shouldRestoreFocus = !options || options.restoreFocus !== false;

      component.hidden = true;

      if (document.body) document.body.style.overflow = previousBodyOverflow;
      document.documentElement.style.overflow = previousHtmlOverflow;

      if (shouldRestoreFocus && previousFocus && typeof previousFocus.focus === 'function' && document.contains(previousFocus)) {
        previousFocus.focus();
      }

      previousFocus = null;
      pendingCheckout = null;
      isContinuing = false;
    }

    function resumeOriginalCheckout(checkout) {
      if (!checkout) return;

      var control = checkout.control;

      if (control && document.contains(control) && typeof control.click === 'function') {
        bypassControl = control;
        control.click();

        window.setTimeout(function () {
          if (bypassControl === control) bypassControl = null;
        }, 0);

        return;
      }

      window.location.assign(checkout.destination || getShopRoot() + 'checkout');
    }

    function handleCheckoutAttempt(event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;

      var control = target.closest(checkoutSelector);
      if (!isCheckoutControl(control) || isUnavailable(control)) return;

      if (bypassControl === control) {
        bypassControl = null;
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      if (isCheckingCart || !component.hidden) return;

      isCheckingCart = true;
      setControlBusy(control, true);

      var checkout = {
        control: control,
        destination: getCheckoutDestination(control)
      };

      getCart()
        .then(function (cart) {
          var hasLabels = atlpCartContainsLabels(cart);
          setLabelCartState(hasLabels);

          if (hasLabels) {
            pendingCheckout = checkout;
            openModal(control);
            return;
          }

          resumeOriginalCheckout(checkout);
        })
        .catch(function (error) {
          console.warn('[ATLP Label Check] Cart check failed; continuing to checkout.', error);
          resumeOriginalCheckout(checkout);
        })
        .finally(function () {
          isCheckingCart = false;
          setControlBusy(control, false);
        });
    }

    function handleModalKeydown(event) {
      if (component.hidden) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
        return;
      }

      if (event.key !== 'Tab') return;

      var focusable = getFocusableElements();
      if (!focusable.length) {
        event.preventDefault();
        return;
      }

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    document.addEventListener('click', handleCheckoutAttempt, true);
    document.addEventListener('keydown', handleModalKeydown);

    if (closeButton) {
      closeButton.addEventListener('click', function () {
        closeModal();
      });
    }

    if (overlay) {
      overlay.addEventListener('click', function (event) {
        if (event.target === overlay) closeModal();
      });
    }

    if (confirmButton) {
      confirmButton.addEventListener('click', function () {
        if (isContinuing || !pendingCheckout) return;

        isContinuing = true;
        var checkout = pendingCheckout;
        closeModal({ restoreFocus: false });
        resumeOriginalCheckout(checkout);
      });
    }

    if (guideLink) {
      guideLink.addEventListener('click', function () {
        closeModal({ restoreFocus: false });
      });
    }

    ['cart:updated', 'cart:update', 'cart:refresh', 'theme:cart:updated', 'ajaxCart.afterCartLoad'].forEach(function (eventName) {
      document.addEventListener(eventName, scheduleAcceleratedCheckoutRefresh);
    });

    window.addEventListener('pageshow', scheduleAcceleratedCheckoutRefresh);

    window.atlpCartContainsLabels = atlpCartContainsLabels;
    window.ATLPLabelCheck = {
      cartContainsLabels: atlpCartContainsLabels,
      refresh: refreshAcceleratedCheckoutState
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleAcceleratedCheckoutRefresh, { once: true });
    } else {
      scheduleAcceleratedCheckoutRefresh();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
